import React from 'react';
import {
  Box,
  Heading,
  Text,
  Flex,
} from '@chakra-ui/react';
import { useUser } from '../Context/UserContext';
import DashboardController from '../Dashboard/DashboardController';

const MainPage = () => {
  const { user } = useUser();

  const getCurrentDate = () => {
    const date = new Date();
    return date.toLocaleDateString('pt-BR', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <Box width="100%" px={{ base: 2, md: 4 }}>
      <Flex direction="column" mb={6}>
        <Heading as="h1" size="xl" mb={2} color="gray.700">
          Bem-vindo, {user.username}
        </Heading>
        <Text color="gray.500" fontSize="md">
          {getCurrentDate()}
        </Text>
        {user.permissions && (
          <Text color="gray.500" fontSize="sm">
            Cargo: {user.permissions.join(', ')}
          </Text>
        )}
      </Flex>

      {/* Load the appropriate dashboard based on user role */}
      <DashboardController />
    </Box>
  );
};

export default MainPage;